export const SKU_STORE = 'SKU_STORE';
export const SKU_UPDATE = 'SKU_UPDATE';
export const SKU_DESTROY = 'SKU_DESTROY';
